var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"page-container"},[_c('img',{ref:"imageRef",staticClass:"image",attrs:{"src":_vm.entity.videoUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }